module.exports = __webpack_public_path__ + "img/location.c81b52b0.png";